

import styled from 'styled-components';









const Page = styled.div.attrs((props) => ({
  style: { ...props.style }
}))`${(props) => props.computedStyle}`;

export default Page;